import { currencies } from "@@/shared/currencies/currencies";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { UUID } from "@@/shared/uuid";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type InitiateSwishRefundCommand = {
    readonly _id: string;
    readonly _type: "SWISH_INITIATE_REFUND_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly paymentUUID: UUID;
    /**
     * Pris i öre
     * @type {number}
     */
    readonly requestedRefundAmount: number;
    readonly currency: "SEK";
    readonly reason?: string;
    readonly reasonCode?: string;
    readonly initiatedBy: UserId;
    readonly towniSessionId: string;
    readonly towniRequestId: string;
};

type FactoryParams = Except<
    InitiateSwishRefundCommand,
    "_id" | "_createdAt" | "_type"
>;
const initiateSwishRefundCommandFactory = (
    params: FactoryParams,
): InitiateSwishRefundCommand => {
    return {
        _id: generateId({ prefix: "swish_initiate_refund_command__" }),
        _createdAt: nowIsoAndUnix(),
        _type: "SWISH_INITIATE_REFUND_COMMAND",
        ...params,
    };
};

const initiateSwishRefundCommandZodSchema: z.ZodSchema<InitiateSwishRefundCommand> =
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("SWISH_INITIATE_REFUND_COMMAND"),
        paymentUUID: z.string() as unknown as z.ZodSchema<UUID>,
        requestedRefundAmount: z.number().int().min(0),
        currency: z.enum(currencies),
        reason: z.string().optional(),
        reasonCode: z.string().optional(),
        initiatedBy: userIdZodSchema,
        towniSessionId: z.string(),
        towniRequestId: z.string(),
    });

export {
    initiateSwishRefundCommandFactory as createInitiateSwishRefundCommand,
    initiateSwishRefundCommandZodSchema,
};
export type { InitiateSwishRefundCommand };
